window.onscroll=function(){changeMenu()}

function changeMenu() {
    var scrollBarPosition = window.pageYOffset | document.body.scrollTop;

    // if at the top
    if(scrollBarPosition == 0) return document.querySelector('.header').classList.remove('is-scrolled');
    
    document.querySelector('.header').classList.add('is-scrolled');
}